import axios from "axios";
import { Form } from "devextreme-react";
import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import DataSource from "devextreme/data/data_source";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import IRBRelatedActivitiesForm from "./IRBRelatedActivitiesForm";
import { updateContrNo, updateSiteNo, updateTaskCodeListId } from "./Redux/IRB";
import IRBClinicalSiteForm from "./IRBClinicalSiteForm";
import VersionTracking from "./VersionTracking";
import IRBFee from "./IRBFee";

const IRBFormWrapper = styled.div`
  .dx-field-item-required-mark {
    color: red;
  }

  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function IRBForm(props) {
  const { sales, IRBGridRef, taskDataSource, setIRBPopupVisible } = props;

  const dispatch = useDispatch();

  const IRB = useSelector((state) => state.IRB);

  // const [step, setStep] = useState(0);

  const [siteDataSource, setSiteDataSource] = useState(null);
  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/siteInfo/${sales.contrNo}`
      );

      if (mounted) {
        setSiteDataSource(
          new DataSource({
            store: {
              data: result.data,
              type: "array",
              key: "siteNo",
            },
          })
        );
      }
    };

    fetchData();

    dispatch(
      updateContrNo({
        contrNo: sales.contrNo,
      })
    );

    // Cleanup: Set mounted to false
    return () => {
      mounted = false;
    };
  }, [sales.contrNo]);

  const itemRender = ({ siteNo, yadmNm, INSPCT_MANAGER_NAME }) => {
    return (
      <div>
        {/* {siteNo}-{LAB_NAME}-{INSPCT_MANAGER_NAME} */}
        {siteNo}-{yadmNm}-{INSPCT_MANAGER_NAME}
      </div>
    );
  };

  const displayExpr = (item) => {
    if (item) {
      // return `${item.siteNo}-${item.LAB_NAME}-${item.INSPCT_MANAGER_NAME}`;
      return `${item.siteNo}-${item.yadmNm}-${item.INSPCT_MANAGER_NAME}`;
    } else {
      return null;
    }
  };

  const onSiteNoValueChanged = (e) => {
    dispatch(
      updateSiteNo({
        siteNo: e.value,
      })
    );
  };

  return (
    <IRBFormWrapper>
      <Form
        id="form-IRB"
        colCount={4}
        labelMode="outside"
        labelLocation="top"
        showColonAfterLabel={true}
        style={{
          padding: "16px",
        }}
        validationGroup="IRBData"
      >
        <SimpleItem
          dataField={"siteNo"}
          colSpan={2}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: siteDataSource,
            valueExpr: "siteNo",
            showClearButton: true,
            value: IRB.siteNo,
            readOnly: IRB.action == "insert" ? false : true,
            itemRender: itemRender,
            displayExpr: displayExpr,
            onValueChanged: onSiteNoValueChanged,
          }}
        >
          <Label text={"Site Info"} />
          <RequiredRule message={"Site info. is required."} />
        </SimpleItem>
      </Form>
      {IRB.siteNo && IRB.step == 0 && (
        <IRBRelatedActivitiesForm
          // step={step}
          // setStep={setStep}
          taskDataSource={taskDataSource}
        />
      )}
      {IRB.siteNo && IRB.step == 1 && (
        <IRBClinicalSiteForm
          // step={step}
          // setStep={setStep}
          sales={sales}
        />
      )}
      {IRB.siteNo && IRB.step == 2 && (
        <VersionTracking
        // step={step} setStep={setStep}
        />
      )}
      {IRB.siteNo && IRB.step == 3 && (
        <IRBFee
          // step={step}
          // setStep={setStep}
          IRBGridRef={IRBGridRef}
          setIRBPopupVisible={setIRBPopupVisible}
        />
      )}
    </IRBFormWrapper>
  );
}
